import { render, staticRenderFns } from "./SiteAlias.vue?vue&type=template&id=716461a2&"
import script from "./SiteAlias.vue?vue&type=script&lang=js&"
export * from "./SiteAlias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports